import * as Common from "@sp-crm/core";
import { ITenant } from "@sp-crm/core";
import { createSelector } from "reselect";
import { ClientState } from "store/reducers/clients";
import { SettingsState } from "store/reducers/settings";
import { ApplicationState } from "store/state";
import { PermissionsState } from "../reducers/permissions";
import { UserState } from "../reducers/users";
import {
    getClients,
    getCommunities,
    getCommunitySearches,
    getPermissions,
    getRegion,
    getSettings,
    getTenant,
    getUsers,
    getUserState,
} from "./base";

export const getClient = createSelector(
    getClients,
    (_clientState: ApplicationState, placementId: Common.PlacementId) => placementId,
    (clientState: ClientState, placementId: Common.PlacementId): Common.IPlacement => {
        return Common.Client.load(clientState.clients[placementId]);
    },
);

const baseAppDataLoaded = createSelector(
    getTenant,
    getUsers,
    getPermissions,
    getSettings,
    (
        tenant: ITenant,
        userState: UserState,
        permissionsState: PermissionsState,
        settingsState: SettingsState,
    ) =>
        !!tenant &&
        userState.usersLoadedOnce &&
        permissionsState.permissionsLoadedOnce &&
        settingsState.legacyQuestionsLoaded,
);

export {
    baseAppDataLoaded,
    getClients,
    getCommunities,
    getCommunitySearches,
    getPermissions,
    getRegion,
    getTenant,
    getUserState,
    getUsers,
};
